import { render, staticRenderFns } from "./Statements.vue?vue&type=template&id=77ac723c"
import script from "./Statements.vue?vue&type=script&lang=js"
export * from "./Statements.vue?vue&type=script&lang=js"
import style0 from "./Statements.vue?vue&type=style&index=0&id=77ac723c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports